const genMinValue = (value: number, diffValue: number) => {
  if ((value - diffValue) < 0) {
    return 0;
  }

  return value - diffValue;
};

export default genMinValue;